import { c as _c } from "react/compiler-runtime";
// Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.
// svgs/light/2.svg: path and width byte-identical (components/icons, Phase 5).
export default function Light2Icon(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M148 64c-28.8 0-56.9 11.5-77.2 31.8L43.3 123.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L48.2 73.1C74.6 46.8 110.9 32 148 32c76.5 0 140 61.9 140 138.8c0 38.4-15.9 75-43.9 101.3L56.5 448 304 448c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 480c-6.6 0-12.5-4-14.9-10.1s-.9-13.1 3.9-17.6L222.2 248.7c21.5-20.2 33.8-48.4 33.8-77.9C256 112 207.2 64 148 64z" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg aria-hidden="true" className={className} data-page-icon="light/2" fill="currentColor" focusable="false" height="1em" overflow="visible" viewBox="0 0 320 512" width="0.625em">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}